import * as serverRequest from "common/utils/serverRequest";
import * as serverPaths from "common/utils/serverPaths";
export function async_sendRequest(dispatch, dto) {
    return serverRequest.postComponentJson(dispatch, serverPaths.orderHdListingsRequest, dto)
        .then((response) => Promise.resolve(true), (error) => Promise.reject(error.message));
}
